import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  downloadCrossDataAsync,
  getComponentDetails,
  getPartsUploadedProgress,
} from 'src/redux/async/electronicTool/electronicTool'
import { getCrossDataDetails } from 'src/redux/async/electronicTool/electronicTool'
import { percentageConverter } from 'src/utils/Functions/electronicToolHelper'

const initialState = {
  defaultCurrency: '$',
  currencyChange: 1,
  nullCellPlacer: '-',
  defaultSelectedProduct: null,
  providedNode: null,
  componentDetailsLoader: false,
  componentDetailsError: '',
  component_details: {},
  crossDataDetailsLoader: false,
  crossDataDetailsError: '',
  cross_data_details: {},
  searchData: '',
  crossDataDownloadLoader: false,
  selectedProductId: null,
  defaultOwner: null,

  // view Saved summary states
  isSaved: false,
  scenarioId: null,

  // progress bar states
  isPolling: false,
  progressPartsLoader: false,
  totalParts: 0,
  inProgressParts: 0,
  completed: 0,
  progressPercentage: 0,
}

export const electronicToolSlice = createSlice({
  name: 'electronic-tool/data',
  initialState,
  extraReducers: (builder) => {
    // Components part details
    builder.addMatcher(isAnyOf(getComponentDetails.pending), (state) => {
      state.componentDetailsLoader = true
      state.component_details = {}
    })
    builder.addMatcher(isAnyOf(getComponentDetails.fulfilled), (state, action) => {
      state.componentDetailsLoader = false
      state.component_details = action.payload.data
      state.componentDetailsError = ''
    })
    builder.addMatcher(isAnyOf(getComponentDetails.rejected), (state, action) => {
      state.componentDetailsLoader = false
      state.componentDetailsError = action.payload
    })
    // Alternate part details
    builder.addMatcher(isAnyOf(getCrossDataDetails.pending), (state) => {
      state.crossDataDetailsLoader = true
    })
    builder.addMatcher(isAnyOf(getCrossDataDetails.fulfilled), (state, action) => {
      state.crossDataDetailsLoader = false
      state.cross_data_details = action.payload
      state.crossDataDetailsError = ''
    })
    builder.addMatcher(isAnyOf(getCrossDataDetails.rejected), (state, action) => {
      state.crossDataDetailsLoader = false
      state.crossDataDetailsError = action.payload
    })
    // Download Alternate part details
    builder.addMatcher(isAnyOf(downloadCrossDataAsync.pending), (state) => {
      state.crossDataDownloadLoader = true
    })
    builder.addMatcher(isAnyOf(downloadCrossDataAsync.fulfilled), (state, action) => {
      state.crossDataDownloadLoader = false
    })
    builder.addMatcher(isAnyOf(downloadCrossDataAsync.rejected), (state, action) => {
      state.crossDataDownloadLoader = false
    })
    // get progress parts
    builder.addMatcher(isAnyOf(getPartsUploadedProgress.pending), (state) => {
      state.progressPartsLoader = true
    })
    builder.addMatcher(isAnyOf(getPartsUploadedProgress.fulfilled), (state, action) => {
      state.progressPartsLoader = false
      state.totalParts = action.payload.data?.total_parts ?? 0
      state.completed = action.payload.data?.completed
      state.inProgressParts = action.payload.data?.started_and_InProgress
      state.isPolling = action.payload.data?.status === 'in_progress'
      state.progressPercentage = percentageConverter(
        action.payload.data?.completed,
        action.payload.data?.total_parts,
      )
    })
    builder.addMatcher(isAnyOf(getPartsUploadedProgress.rejected), (state, action) => {
      state.progressPartsLoader = false
      state.totalParts = 0
      state.completed = 0
      state.inProgressParts = 0
      state.isPolling = false
    })
  },
  reducers: {
    resetProgressParts: (state, action) => {
      state.totalParts = 0
      state.completed = 0
      state.inProgressParts = 0
      state.progressPartsLoader = false
      state.progressPercentage = 0
    },
    setIsPolling: (state, action) => {
      state.isPolling = action.payload
    },
    setDefaultSelectedProduct: (state, action) => {
      state.defaultSelectedProduct = action.payload
    },
    setNullCellPlacer: (state, action) => {
      state.nullCellPlacer = action.payload
    },
    setSavedScenario: (state, action) => {
      state.isSaved = action.payload.isSaved
      state.scenarioId = action.payload.scenarioId
    },
    changeDefaultCurrency: (state, action) => {
      state.defaultCurrency = action.payload
    },
    changeCurrencyExchange: (state, action) => {
      state.currencyChange = action.payload
    },
    changeDefaultOwner: (state, action) => {
      state.defaultOwner = action.payload
    },
    setProvidedNode: (state, action) => {
      state.providedNode = action.payload
    },
    setSearchData: (state, action) => {
      state.searchData = action.payload
    },
    setSelectedProductId: (state, action) => {
      state.selectedProductId = action.payload
    },
    emptyelectronicComponentDetailsSlice: (state) => {
      state.componentDetailsLoader = false
      state.componentDetailsError = ''
      state.component_details = {}
    },
    emptyelectronicCrossDataDetailsSlice: (state) => {
      state.crossDataDetailsLoader = false
      state.crossDataDetailsError = ''
      state.cross_data_details = {}
      state.defaultSelectedProduct = null
    },
  },
})

export const {
  setProvidedNode,
  emptyelectronicComponentDetailsSlice,
  emptyelectronicCrossDataDetailsSlice,
  setSearchData,
  setSavedScenario,
  setSelectedProductId,
  changeDefaultCurrency,
  changeCurrencyExchange,
  setNullCellPlacer,
  setDefaultSelectedProduct,
  setIsPolling,
  resetProgressParts,
  changeDefaultOwner,
} = electronicToolSlice.actions
export default electronicToolSlice.reducer
